let isRunning = false;

function runShippingEstimate() {
  if (isRunning) return;
  const el = document.getElementById('shipping-estimate-text');
  if (!el) return;

  isRunning = true;

  const countryCode = el.dataset.countryCode;
  const shippingLabel = el.dataset.shippingLabel;
  const freeLabel = el.dataset.freeLabel;
  const calculatingLabel = el.dataset.calculatingLabel;

  el.textContent = calculatingLabel;

const zipCodes = {
  'NL': { zip: '1000AA', province: '' },
  'DE': { zip: '10115', province: '' },
  'BE': { zip: '1000', province: '' },
  'US': { zip: '10001', province: 'NY' },
  'GB': { zip: 'EC1A1BB', province: '' },
  'FR': { zip: '75001', province: '' },
  'ES': { zip: '28001', province: '' },
  'IT': { zip: '00100', province: '' },
  'AU': { zip: '2000', province: 'NSW' }
};
const location = zipCodes[countryCode] || { zip: '10000', province: '' };
const zip = location.zip;
const province = location.province;

const provinceParam = province ? '&shipping_address[province]=' + province : '';

fetch('/cart/shipping_rates.json?shipping_address[country]=' + countryCode + '&shipping_address[zip]=' + zip + provinceParam)
    .then(r => r.json())
    .then(data => {
      const rates = data.shipping_rates;
      if (!rates || rates.length === 0) { el.textContent = ''; return; }
      const lowest = rates.reduce((a, b) => parseFloat(a.price) <= parseFloat(b.price) ? a : b);
      const price = parseFloat(lowest.price);
      const formatted = new Intl.NumberFormat(
        document.documentElement.lang || 'nl',
        { style: 'currency', currency: lowest.currency }
      ).format(price);
      el.textContent = price === 0 ? freeLabel : shippingLabel + ': ' + formatted;
    })
    .catch(() => { el.textContent = ''; })
    .finally(() => { isRunning = false; });
}

// Initiële aanroep
runShippingEstimate();

// Onderschep Dawn's cart AJAX-updates
const originalFetch = window.fetch;
window.fetch = function(...args) {
  const result = originalFetch.apply(this, args);
  const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
  if (url.includes('/cart') && !url.includes('shipping_rates')) {
    result.then(() => setTimeout(runShippingEstimate, 500));
  }
  return result;
};
